import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

const JDModal = ({ name, message, showModal, setShowModal }) => {
  const navigate = useNavigate();
  return (
    <>
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Analysis of {name}'s job description
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="alert alert-success mt-3 sm" role="alert">
           Full analysis has been sent to your email!
          </div>
          <div
            style={{ maxHeight: '400px', overflowY: 'auto' }}
            dangerouslySetInnerHTML={{ __html: message }}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => {
              setShowModal(false);
              //navigate(redirectUrl);
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
JDModal.propTypes = {
  message: PropTypes.any,
  showModal: PropTypes.any,
  redirectUrl: PropTypes.string,
  setShowModal: PropTypes.func,
  name: PropTypes.string
};
export default JDModal;
